"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CharacteristicsDetails = _ref => {
  let {
    characteristic
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 5,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 1,
    justify: 'left',
    weight: 1,
    text: characteristic.name,
    noMargin: true
  })), characteristic.productSpecCharacteristicValue.map((_ref2, index) => {
    let {
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      key: index,
      justify: "left",
      weight: 2
    }, value);
  }));
};
var _default = CharacteristicsDetails;
exports.default = _default;